import React from 'react';
import { ClockIcon, CalendarCheckIcon } from 'lucide-react';
import { priceList, priceListImage, priceOrder } from '../data/business';
import { useLanguage } from '../contexts/LanguageContext';
import { formatDuration } from '../utils/duration';
export function Services() {
  const {
    lang,
    t
  } = useLanguage();
  const standard = priceOrder.filter(id => !priceList[id].featured);
  const premium = priceOrder.filter(id => priceList[id].featured);
  return <section id="servicios" className="w-full bg-panelAlt py-20 lg:py-28" data-id="element-260" data-mp="13xxtz1pmntjt">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-261" data-mp="z3ld8zfjcwbr">
        <div className="max-w-2xl" data-id="element-262" data-mp="u5jtsde76uzr">
          <p className="mb-4 text-xs uppercase tracking-[0.28em] text-gold" data-id="element-263" data-mp="u6l3adfkf9fd">{t.services.eyebrow}</p>
          <h2 className="font-display text-3xl font-bold uppercase leading-tight text-cream sm:text-4xl lg:text-[2.9rem]" data-id="element-264" data-mp="q61afm20yrz1">
            {t.services.title}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-cream/75 lg:text-lg" data-id="element-265" data-mp="g60mfmt7nnoi">
            {t.services.intro}
          </p>
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-[1.1fr_0.9fr] lg:gap-12" data-id="element-266" data-mp="36b6gg8qygc8k">
          <div data-id="element-267" data-mp="3b3zi2nr4n4gf">
            <ul className="divide-y divide-white/10 border-y border-white/10" data-id="element-268" data-mp="3b4heplhpbkov">
              {standard.map(id => {
              const item = t.services.items[id];
              const entry = priceList[id];
              return <li key={id} className="flex items-baseline justify-between gap-6 py-4 sm:py-5" data-id="element-269" data-mp="3q0qd6ktrpu08">
                    <div className="min-w-0" data-id="element-270" data-mp="3u192o886unz9">
                      <h3 className="font-display text-lg uppercase tracking-wide text-cream sm:text-xl" data-id="element-271" data-mp="3g2sojw7zxv73">
                        {item.title}
                      </h3>
                      {item.detail && <p className="mt-1 text-sm leading-snug text-cream/60" data-id="element-272" data-mp="24m2o6tq97xle">{item.detail}</p>}
                      <p className="mt-1.5 flex items-center gap-1.5 text-xs text-cream/45" data-id="element-273" data-mp="29ns1kg0y8ncn">
                        <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-274" data-mp="1piswecd4yxjj" />
                        {formatDuration(entry.minutes, lang)}
                      </p>
                    </div>
                    <span className="shrink-0 font-display text-xl font-semibold text-gold sm:text-2xl" data-id="element-275" data-mp="1gqqzup66u1ej">
                      {entry.price ?? t.services.priceVaries}
                    </span>
                  </li>;
            })}
            </ul>

            <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-276" data-mp="11urpt8zipr6r">
              {premium.map(id => {
              const item = t.services.items[id];
              const entry = priceList[id];
              return <div key={id} className="flex flex-col rounded-sm border border-gold/35 bg-ink p-6" data-id="element-277" data-mp="suljq865fthm">
                    <span className="w-fit rounded-sm bg-gold px-2.5 py-1 font-display text-[11px] font-semibold uppercase tracking-widest text-ink" data-id="element-278" data-mp="2n7uvk6m63r31">
                      {t.services.badge}
                    </span>
                    <h3 className="mt-4 font-display text-xl uppercase tracking-wide text-cream" data-id="element-279" data-mp="2zpx7ix8f9wdh">
                      {item.title}
                    </h3>
                    {item.detail && <p className="mt-2 text-sm leading-relaxed text-cream/65" data-id="element-280" data-mp="39g07jhdyoalb">{item.detail}</p>}
                    <div className="mt-auto flex items-end justify-between gap-4 pt-6" data-id="element-281" data-mp="2btay4mgxivpf">
                      <span className="flex items-center gap-1.5 text-xs text-cream/45" data-id="element-282" data-mp="2gr2v3uwfl80h">
                        <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-283" data-mp="2lqxllxcanvl0" />
                        {formatDuration(entry.minutes, lang)}
                      </span>
                      <span className="font-display text-2xl font-semibold text-gold" data-id="element-284" data-mp="2ppxy6y46i1zk">
                        {entry.price}
                      </span>
                    </div>
                  </div>;
            })}
            </div>

            <p className="mt-6 text-sm leading-relaxed text-cream/50" data-id="element-285" data-mp="3lxrv6i16klu">{t.services.note}</p>

            <a href="#agendar" className="mt-7 inline-flex items-center justify-center gap-2 rounded-sm bg-gold px-7 py-4 font-display text-sm font-semibold uppercase tracking-wider text-ink transition-colors duration-150 ease-out hover:bg-gold-light" data-id="element-286" data-mp="3urz95wslaafx">
              <CalendarCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-287" data-mp="miyz6xz24wsy" />
              {t.hero.ctaBook}
            </a>
          </div>

          <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-288" data-mp="hk4f7spct279">
            <img src={priceListImage} alt={t.services.imageAlt} className="w-full rounded-sm border border-gold/25 bg-black object-contain" data-id="element-289" data-mp="w9tl218e5udv" />
          </div>
        </div>
      </div>
    </section>;
}